'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_app$002eutils$002e$002dNewtype$002dMass from "./app.utils.-Newtype-Mass.js";
import * as $j_app$002eutils$002e$002dNewtype$002dMass$0024$0024anon$00241 from "./app.utils.-Newtype-Mass$$anon$1.js";
import * as $j_app$002eutils$002e$002dNewtype$002dMass$0024$0024anon$00243 from "./app.utils.-Newtype-Mass$$anon$3.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$() {
  this.aJP = null;
  this.aJQ = false;
  this.aJJ = null;
  this.aJK = false;
  this.aJH = null;
  this.aJI = false;
  this.aJN = null;
  this.aJO = false;
  this.aJR = null;
  this.aJS = false;
  this.aJL = null;
  this.aJM = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$.prototype = $p;
$p.aA = (function() {
  if ((!this.aJQ)) {
    this.aJP = new $j_app$002eutils$002e$002dNewtype$002dMass$0024$0024anon$00241.$c_Lapp_utils_NewtypeMass$$anon$1(this);
    this.aJQ = true;
  }
  return this.aJP;
});
$p.iq = (function() {
  if ((!this.aJK)) {
    this.aJJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aJK = true;
  }
  return this.aJJ;
});
$p.il = (function() {
  if ((!this.aJI)) {
    this.aJH = $j_app$002eutils$002e$002dNewtype$002dMass.$f_Lapp_utils_NewtypeMass__empty__Lalleycats_Empty(this);
    this.aJI = true;
  }
  return this.aJH;
});
$p.eY = (function() {
  if ((!this.aJO)) {
    this.aJN = $j_app$002eutils$002e$002dNewtype$002dMass.$f_Lapp_utils_NewtypeMass__given_QuantityEquals_Type__Lapp_data_FormQuantity$QuantityEquals(this);
    this.aJO = true;
  }
  return this.aJN;
});
$p.Jq = (function() {
  if ((!this.aJS)) {
    this.aJR = new $j_app$002eutils$002e$002dNewtype$002dMass$0024$0024anon$00243.$c_Lapp_utils_NewtypeMass$$anon$3(this);
    this.aJS = true;
  }
  return this.aJR;
});
$p.vZ = (function() {
  if ((!this.aJM)) {
    this.aJL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Gross Weight";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aJM = true;
  }
  return this.aJL;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$, "app.data.data_point_types$package$GrossWeight$", ({
  FL: 1,
  B: 1,
  C: 1,
  ky: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$ };
//# sourceMappingURL=app.data.data_point_types$package$-Gross-Weight$.js.map
